
const verifiedOptions = [
    {key: 1, label: 'verified'},
    {key: 2, label: 'unverified'}
];

export default verifiedOptions;
